export default class Error {
  constructor(data, code) {
    this.data = data;
    this.code = code;
  }
}
